import React from "react";
import { Modal, Row, Col, Alert, Form, Button } from "react-bootstrap";

class _cookies extends React.Component {

    state={
        show: localStorage.getItem("cookie_terms") ? false : true
    }

    componentDidMount() {
    }

    render() {
        return (
            <Modal
                show={this.state.show}
                keyboard={false}
                backdrop="static"
            >
                <Modal.Header>
                        <h5>Souhlas s používáním cookies</h5>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            Cookies nevyužíváme k jiným než čistě technickým účelům, nespojujeme údaje získané díky nim s jakýmikoliv jinými údaji a pracujeme s cookies tak, že neumožňují identifikovat konkrétní osoby.
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col className="d-flex justify-content-end">
                            <Button variant="success" size="sm" onClick={() => {
                                localStorage.setItem("cookie_terms",false);
                                this.setState({show: false});
                                }
                            }>Souhlasím s používáním cookies</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        )
    }
}

export default _cookies